import { render, staticRenderFns } from "./Headlines.vue?vue&type=template&id=3b3c59b9&scoped=true&"
import script from "./Headlines.vue?vue&type=script&lang=js&"
export * from "./Headlines.vue?vue&type=script&lang=js&"
import style0 from "./Headlines.vue?vue&type=style&index=0&id=3b3c59b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c59b9",
  null
  
)

export default component.exports